export const TENDER_TYPES = {
  L1: 'Licitación Pública Menor a 100 UTM',
  LE: 'Licitación Pública igual o superior a 100 UTM e inferior a 1.000 UTM',
  LP: 'Licitación Pública igual o superior a 1.000 UTM e inferior a 2.000 UTM',
  LQ: 'Licitación Pública igual o superior a 2.000 UTM e inferior a 5.000 UTM',
  LR: 'Licitación Pública igual o superior a 5.000 UTM',
  E2: 'Licitación Privada Menor a 100 UTM',
  CO: 'Licitación Privada igual o superior a 100 UTM e inferior a 1000 UTM',
  B2: 'Licitación Privada igual o superior a 1000 UTM e inferior a 2000 UTM',
  H2: 'Licitación Privada igual o superior a 2000 UTM e inferior a 5000 UTM',
  I2: 'Licitación Privada Mayor a 5000 UTM',
  LS: 'Licitación Pública Servicios personales especializados',
};

export const CURRENCIES = {
  CLP: 'Peso Chileno',
  CLF: 'Unidad de Fomento',
  USD: 'Dólar Americano',
  UTM: 'Unidad Tributaria Mensual',
  EUR: 'Euro',
};

export const ESTIMATED_AMOUNTS = {
  1: 'Presupuesto Disponible',
  2: 'Precio Referencial',
  3: 'Monto no es posible de estimar',
};

export const PAYMENT_MODALITIES = {
  1: 'Pago a 30 días',
  2: 'Pago a 30, 60 y 90 días',
  3: 'Pago al día',
  4: 'Pago Anual',
  5: 'Pago Bimensual',
  6: 'Pago Contra Entrega Conforme',
  7: 'Pagos Mensuales',
  8: 'Pago Por Estado de Avance',
  9: 'Pago Trimestral',
  10: 'Pago a 60 días',
};

export const TIME_UNITS = {
  1: 'Horas',
  2: 'Días',
  3: 'Semanas',
  4: 'Meses',
  5: 'Años',
};

export const ADMINISTRATIVE_ACT_TYPES = {
  1: 'Autorización',
  2: 'Resolución',
  3: 'Acuerdo',
  4: 'Decreto',
  5: 'Otros',
};

export const getTenderFieldTranslation = (
  field: string,
  value: string | number | null,
): string => {
  if (value === null || value === undefined) return 'No disponible';

  const stringValue = String(value);

  switch (field) {
    case 'type':
      return (
        TENDER_TYPES[stringValue as keyof typeof TENDER_TYPES] || stringValue
      );
    case 'currency':
      return CURRENCIES[stringValue as keyof typeof CURRENCIES] || stringValue;
    case 'estimatedAmount':
      return (
        ESTIMATED_AMOUNTS[value as keyof typeof ESTIMATED_AMOUNTS] ||
        stringValue
      );
    case 'paymentType':
      return (
        PAYMENT_MODALITIES[value as keyof typeof PAYMENT_MODALITIES] ||
        stringValue
      );
    case 'timeUnit':
    case 'contractDurationUnit':
      return TIME_UNITS[value as keyof typeof TIME_UNITS] || stringValue;
    case 'administrativeActType':
      return (
        ADMINISTRATIVE_ACT_TYPES[
          value as keyof typeof ADMINISTRATIVE_ACT_TYPES
        ] || stringValue
      );
    default:
      return stringValue;
  }
};
